import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const { user, login, checking } = useAuth();
  const [email, setEmail] = useState('admin@keratina.it');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checking) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF8F3] px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="font-serif text-2xl tracking-[0.2em] uppercase mb-2">COSMETISSAGE<sup className="text-[0.5em] ml-0.5 text-[#C5A059] font-sans">®</sup></div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#3D2817]/60">Admin Panel</div>
        </div>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-widest text-[#3D2817]/60">Email</label>
            <input
              data-testid="admin-email"
              required type="email" value={email} onChange={e => setEmail(e.target.value)}
              className="underline-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#3D2817]/60">Password</label>
            <input
              data-testid="admin-password"
              required type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="underline-input"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full mt-8 bg-[#3D2817] hover:bg-[#C5A059] text-white text-sm uppercase tracking-[0.25em] py-4 transition-all duration-500"
          >
            {loading ? '...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
